import { render, staticRenderFns } from "./pandianList.vue?vue&type=template&id=1717c25c&scoped=true&"
import script from "./pandianList.vue?vue&type=script&lang=js&"
export * from "./pandianList.vue?vue&type=script&lang=js&"
import style0 from "./pandianList.vue?vue&type=style&index=0&id=1717c25c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1717c25c",
  null
  
)

export default component.exports